export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Soothing gradient backdrop */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#E8F1F5] via-[#D1E3EA] to-[#F0F4F8]"></div>
      
      {/* Soft wave pattern overlay */}
      <div className="absolute inset-0 opacity-30">
        <svg className="absolute w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 800" preserveAspectRatio="none">
          <path fill="#2F7FB7" fillOpacity="0.1" d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,149.3C672,149,768,203,864,213.3C960,224,1056,192,1152,165.3C1248,139,1344,117,1392,106.7L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
          <path fill="#5A9FD4" fillOpacity="0.08" d="M0,320L48,314.7C96,309,192,299,288,282.7C384,267,480,245,576,250.7C672,256,768,288,864,293.3C960,299,1056,277,1152,250.7C1248,224,1344,192,1392,176L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
          <path fill="#2F7FB7" fillOpacity="0.05" d="M0,480L48,458.7C96,437,192,395,288,394.7C384,395,480,437,576,448C672,459,768,437,864,410.7C960,384,1056,352,1152,346.7C1248,341,1344,363,1392,373.3L1440,384L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      </div>

      {/* Floating organic shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#2F7FB7]/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-40 right-20 w-96 h-96 bg-[#5A9FD4]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/3 w-48 h-48 bg-[#2F7FB7]/5 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/3 right-1/4 w-40 h-40 bg-[#5A9FD4]/8 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '3s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Left content - 60% */}
          <div className="md:col-span-3 space-y-8">
            <div className="space-y-6">
              <h1 className="text-6xl md:text-7xl font-serif text-[#2F7FB7] leading-tight">
                Welcome to<br />RECOVER
              </h1>
              <p className="text-2xl text-[#4A5568] font-light max-w-xl">
                A calm, supportive space created to help you slow down, find steadiness, and gently reconnect with balance.
              </p>
              <p className="text-lg text-[#6B7280] leading-relaxed max-w-xl">
                In a world where mental health apps are growing rapidly, many people find themselves overwhelmed by too much information and not enough human connection. RECOVER offers a thoughtful, human-centred approach focused on your experience, your pace, and your needs.
              </p>
            </div>

            <div className="space-y-4">
              <a href="/download" className="bg-[#2F7FB7] text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-[#1E5A8E] transition-all hover:shadow-xl inline-flex items-center gap-3 cursor-pointer whitespace-nowrap group">
                Begin Your Journey
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </a>
              <p className="text-sm text-[#6B7280] flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#5A9FD4]"></span>
                Evidence-based
                <span className="w-1.5 h-1.5 rounded-full bg-[#5A9FD4]"></span>
                40+ years experience
              </p>
            </div>
          </div>

          {/* Right visual - 40% */}
          <div className="md:col-span-2">
            <div className="relative">
              <div className="bg-white/60 backdrop-blur-sm rounded-[32px] p-8 shadow-2xl hover:shadow-3xl transition-all duration-500 hover:-translate-y-2">
                <img 
                  src="/hero-app-mockup.png"
                  alt="Recover App Peaceful Illustration"
                  className="w-full h-auto rounded-2xl object-cover"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-[#5A9FD4]/20 rounded-full blur-xl"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-[#2F7FB7]/15 rounded-full blur-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
